<template>
  <BLayoutList
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="form-data"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:view="onViewRevisions"
      @action:tpl-download="onActionDownload"
      @action:tpl-download-empty="onActionDownloadEmpty"
      @action:tpl-upload="onActionUpload"
    />
    <input
      v-show="false"
      ref="input"
      type="file"
      @input="onFileChoose($event.target.files)"
    >
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { FormDataModel as Model } from './Model'
import { formsHandbookStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/FormDataFilter.vue'
import { createLKPublicationsFormdataRevisionsListModal } from '@/views/LKPublications/formdata/utils'
import { LkFormTemplateApi } from '@/api/resources'
import { downloadLinkByGet } from '@/helpers/downloadBlob'
import { LkDataCollectionsApi } from '@/api/resources/LkDataCollectionsApi'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)


/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'FormDataList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  data: () => ({
    dataCollectionId: null,
  }),
  methods: {
    async onFileChoose(files) {
      if (this.dataCollectionId === null) return
      const api = new LkDataCollectionsApi()
      const [file] = files
      const unwatch = this.uploadCallback?.()
      try {
        await api.uploadTemplate(this.dataCollectionId, file)
        this.$notice.create({ type: 'success', text: 'Предзаполнение загружено' })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.$refs.input.value = null
        this.dataCollectionId = null
        unwatch?.()
      }
    },
    async onViewRevisions(data) {
      const propsData = { data, form_template_id: data.data_collection.form_template_id }
      const modal = await createLKPublicationsFormdataRevisionsListModal(this, propsData)
      modal.open()
    },
    async onActionDownload(data, callback) {
      const unwatch = callback?.()

      const api = new LkFormTemplateApi()
      const link = `${api.getTemplate(data.data_collection.form_template_id)}?form_data_id=${data.id}`
      try {
        await downloadLinkByGet(link, `${data.data_collection.name}.xlsx`)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
    async onActionDownloadEmpty(data, callback) {
      const unwatch = callback?.()

      const api = new LkFormTemplateApi()
      const link = api.getTemplate(data.data_collection.form_template_id)
      try {
        await downloadLinkByGet(link, `${data.data_collection.name}.xlsx`)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
    onActionUpload(data, callback) {
      this.uploadCallback = callback
      this.dataCollectionId = data.data_collection_id
      this.$refs.input.click()
    },
  },
}
</script>
